const data = [
  
  {
    Name: "Aaditya Khot",
    Board: "Main",
    Position: "President",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624822/sait%20images/Aaditya_Khot_mdefbn.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/aaditya-khot-111672229?fbclid=PAAaZDIuIFS2QRQ6CoGWm86_SwCeAOELYfAjNmcVcw69YzWOoIcu68smliHEg&original_referer=https%3A%2F%2Fl.instagram.com%2F",
    GitHubProfile: "https://github.com/aadityafour7",
    InstagramProfile:
      "https://instagram.com/aaditya._.47?igshid=MzRlODBiNWFlZA==",
  },

  {
    Name: "Vedant Vedpathak",
    Board: "Main",
    Position: "Vice President",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Vedant_Vedpathak_llp6e0.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-vedpathak-b54384229",
    GitHubProfile: "https://github.com/vedantv3",
    InstagramProfile:
      "https://instagram.com/_vedantv3_?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  
  {
    Name: "Pranav Kadam",
    Board: "Main",
    Position: "Secretary",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624852/sait%20images/Pranav_Kadam_jujkis.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/pranav-kadam-7947b5232/",
    GitHubProfile: "github.com/pranav-kadam",
    InstagramProfile: "-",
  },
  {
    Name: "Mitali Patil ",
    Board: "Main",
    Position: "Secretary ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624850/sait%20images/Mitali_Patil_n7cc6z.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mitali-patil-3ab106231",
    GitHubProfile: "https://github.com/mitupatil18",
    InstagramProfile:
      "https://instagram.com/mitaliiiiipatil?igshid=MzRlODBiNWFlZA==",
  },
  
  {
    Name: "Viraj Takone",
    Board: "Main",
    Position: "Program Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624880/sait%20images/Viraj_Takone_noff14.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/viraj-takone-a93745224",
    GitHubProfile: "https://GitHub.com/viru04",
    InstagramProfile: "https://instagram.com/viraj_a_t",
  },
  
  {
    Name: "Shriya Patil ",
    Board: "Main",
    Position: "Program Director ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624873/sait%20images/Shriya_Patil_zsd80j.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shriya-patil-b9082b234",
    GitHubProfile: "https://github.com/shriya4545",
    InstagramProfile:
      "https://instagram.com/shriyapatil_?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D",
  },
  
  {
    Name: "Aaditya Patil ",
    Board: "Main",
    Position: "Program Director ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624821/sait%20images/Aaditya_Patil_krvs6w.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aadi-exe",
    GitHubProfile: "https://github.com/Aaditya123-exe",
    InstagramProfile:
      "https://instagram.com/aadityapatil345?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D",
  },
  {
    Name: "Kedarnath Chavan",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624847/sait%20images/Kedarnath_Chavan_vc5qvt.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kedarnath-chavan-768a92226",
    GitHubProfile: "https://github.com/kedarnathpc",
    InstagramProfile: "https://www.instagram.com/kedarnathpc",
  },
  {
    Name: "Rajan Lature",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624856/sait%20images/Rajan_Lature_a9m5zm.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/rajan-lature-32aa9522a/",
    GitHubProfile: "https://github.com/rajan-1700",
    InstagramProfile: "https://www.instagram.com/rajan_lature/",
  },
  {
    Name: "Kalash Patil",
    Board: "Main",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624846/sait%20images/Kalash_Patil_vvl6jx.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kalashpatil33/",
    GitHubProfile: "https://github.com/kalashpatil33",
    InstagramProfile: "https://www.instagram.com/kalash.patil33/",
  },
  {
    Name: "Saurabh Salunke",
    Board: "Main",
    Position: "Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1704534653/sait%20images/cglrkt5rrlzsmvqvr8fu.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/saurabh-salunke-560448245/",
    GitHubProfile: "https://github.com/SaurabhS55",
    InstagramProfile: "https://www.instagram.com/saurabhsalunke555/",
  },
  {
    Name: "Kaustubh Suroshi",
    Board: "Main",
    Position: "Web Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624847/sait%20images/Kaustubh_Suroshi_r9skyc.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kaustubh-suroshi-75434723a",
    GitHubProfile: "https://github.com/kaustubh-555",
    InstagramProfile: "kaustubh_5500",
  },
  {
    Name: "Shailendra Mahadule",
    Board: "Main",
    Position: "Public Relations Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624861/sait%20images/Shailendra_Mahadule_lbwphl.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/shailendra-mahadule-96955b200",
    GitHubProfile: "https://github.com/Shailendra-08",
    InstagramProfile: "https://www.instagram.com/ayushmahadule/",
  },
  
  {
    Name: "Siddhi Phatak",
    Board: "Main",
    Position: "Public Relations Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Siddhi_Phatak_csekgr.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/siddhi-phatak-491603231",
    GitHubProfile: "https://github.com/SIDDHI100",
    InstagramProfile:
      "https://instagram.com/siddhi__100?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
  },
  {
    Name: "Mohammadsaad Mulla",
    Board: "Main",
    Position: "Public Relation Officer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624858/sait%20images/saad_k6kwaa.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/c0delust/",
    GitHubProfile: "https://github.com/c0delust",
    InstagramProfile: "https://www.instagram.com/c0delust/",
  },
  {
    Name: "Himanshu Mude",
    Board: "Main",
    Position: "Aptitude Developer",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624851/sait%20images/Himanshu_Mude_ccryzb.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/himanshu-mude-48668622a",
    GitHubProfile: "github.com/HimanshuMude",
    InstagramProfile:
      "https://instagram.com/himanshu_mude?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Parth Kulkarni ",
    Board: "Main",
    Position: "Aptitude Developer ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624878/sait%20images/Parth_Kulkarni_nb4iqy.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/parth-kulkarni-554978233",
    GitHubProfile: "https://github.com/Parthk26",
    InstagramProfile:
      "https://instagram.com/parth_k026?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Sana Mulani",
    Board: "Main",
    Position: "Art Designer & Editor ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624858/sait%20images/Sana_Mulani_zvqtpx.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sana-mulani-758074258",
    GitHubProfile: "https://github.com/SanaMulani1108",
    InstagramProfile:
      "https://instagram.com/sana_mulani1108?igshid=NGExMmI2YTkyZg==",
  },
  {
    Name: "Prerna  Pawar ",
    Board: "Main",
    Position: "Art designer and Editor ",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624868/sait%20images/Prerna_Pawar_tjnp53.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/prerna-pawar-673531234",
    GitHubProfile: "https://github.com/Prerna-Pawar",
    InstagramProfile: "https://www.instagram.com/prerna_pawar.14/saved/",
  },
  {
    Name: "Shravani Umare",
    Board: "Main",
    Position: "Art designer and Editor",
    Photo:
      "https://res.cloudinary.com/du3cgjere/image/upload/v1693624874/sait%20images/Shravani_Umare_aygb68.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shravaniumare03",
    GitHubProfile: "shravani2003",
    InstagramProfile: "shravni.umare3",
  },
];
export default data;
